module.exports = __webpack_public_path__ + "static/media/news-6.52b67591.jpg";